import type { SuggestionProvider } from "../types.js";
import { patternOverlapProvider } from "./providers/pattern-overlap.js";
import { hotspotUndocumentedProvider } from "./providers/hotspot-undocumented.js";
import { graphIslandProvider } from "./providers/graph-island.js";
import { rtkIngestProvider } from "./providers/rtk-ingest.js";

export const defaultProviders: SuggestionProvider[] = [
  patternOverlapProvider,
  hotspotUndocumentedProvider,
  graphIslandProvider,
  rtkIngestProvider,
];
